import {KatCard, KatGridItem} from "@amzn/katal-react";
import * as React from "react";
import {FragmentData, ReviewSectionData} from "src/app/model/ReviewData";
import Fragment from "src/app/component/review/Fragment";

interface ReviewSectionProps {
    data: ReviewSectionData;
}

const ReviewSection = (props: ReviewSectionProps) => {
    const title = props.data.title;
    let fragments;
    if (props.data.fragments instanceof Map) {
        fragments = props.data.fragments;
    } else {
        fragments = new Map<string, FragmentData>(Object.entries(props.data.fragments));
    }

    return (
        <KatGridItem className='section-none-border'>
            <KatCard className='full-height'>
                <span slot='subtitle'>{title}</span>
                <div className='review-section-body'>
                    {Array.from(fragments.entries()).map(([key, fragment]) => (
                        fragment.visible && <Fragment data={fragment.rows} key={key} data-testid="fragment"></Fragment>
                    ))}
                </div>
            </KatCard>
        </KatGridItem>
    )
}

export default ReviewSection;